import { render } from "./Partners.vue?vue&type=template&id=344b8f90&scoped=true"
import script from "./Partners.vue?vue&type=script&lang=js"
export * from "./Partners.vue?vue&type=script&lang=js"

import "./Partners.vue?vue&type=style&index=0&id=344b8f90&scoped=true&lang=css"

import exportComponent from "/Users/agroinnovatech/Development/Agro-Innova/AgroInnovaWebsite/AgroInnovaWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344b8f90"]])

export default __exports__